import React from 'react';
import { ShoppingCart, User, CreditCard, Check } from 'lucide-react';

const CheckoutStepper = ({ currentStep }) => {
  const steps = [
    { id: 1, name: 'Carrinho', icon: ShoppingCart },
    { id: 2, name: 'Identificação', icon: User },
    { id: 3, name: 'Pagamento', icon: CreditCard },
    { id: 4, name: 'Fim', icon: Check }
  ];

  return (
    <div className="w-full bg-white py-8 px-4 mb-8 border-b border-gray-200">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center justify-between relative">
          {steps.map((step, index) => (
            <React.Fragment key={step.id}>
              {/* Step Item */}
              <div className="flex flex-col items-center z-10 relative">
                {/* Icon Circle */}
                <div
                  className={`w-12 h-12 rounded-full flex items-center justify-center transition-all duration-300 ${
                    currentStep >= step.id
                      ? 'bg-[#00A86B] text-white'
                      : 'bg-gray-200 text-gray-400'
                  }`}
                >
                  <step.icon size={24} />
                </div>
                {/* Label */}
                <span
                  className={`mt-2 text-sm font-medium ${
                    currentStep >= step.id ? 'text-[#00A86B]' : 'text-gray-400'
                  }`}
                >
                  {step.name}
                </span>
              </div>

              {/* Connecting Line */}
              {index < steps.length - 1 && (
                <div className="flex-1 h-1 mx-4 relative" style={{ top: '-20px' }}>
                  <div
                    className={`h-full transition-all duration-300 ${
                      currentStep > step.id ? 'bg-[#00A86B]' : 'bg-gray-200'
                    }`}
                  />
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
        
        {/* Security Badge */}
        <div className="mt-6 flex items-center justify-center gap-2 text-sm text-gray-600">
          <svg className="w-5 h-5 text-green-600" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
          </svg>
          <span className="font-semibold text-gray-700">Compra 100% segura processada pelo</span>
          <span className="font-bold text-blue-600">Mercado Pago</span>
        </div>
      </div>
    </div>
  );
};

export default CheckoutStepper;
